import { render, staticRenderFns } from "./IndustrySection.vue?vue&type=template&id=2ba3938e&scoped=true&"
import script from "./IndustrySection.vue?vue&type=script&lang=js&"
export * from "./IndustrySection.vue?vue&type=script&lang=js&"
import style0 from "./IndustrySection.vue?vue&type=style&index=0&id=2ba3938e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba3938e",
  null
  
)

export default component.exports